export default __webpack_public_path__ + "img/765b01bf8af3762d53f1bd1fe8df2ffc.svg";